import styled from "styled-components";

export const PageContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  background-color: #f0e8dd;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0;
`;

export const BackButtonContainer = styled.div`
  width: 100%;
  padding: 24px 40px 0;

  @media (max-width: 768px) {
    padding: 20px 20px 0;
  }
`;

export const BackLink = styled.button`
  background: none;
  border: none;
  color: #5a4e45;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 0.15s;

  &:hover { color: #1a1a1a; }
  &:focus { outline: none; }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  flex: 1;
`;

export const Header = styled.div`
  margin-bottom: 30px;
  text-align: center;
`;

export const Title = styled.h2`
  font-size: 28px;
  font-weight: bold;
  color: #111;
`;
